import $ from 'jquery';

const GMAP_KEY = 'AIzaSyDspHUe2de80pCPqYy9-scfmRzTdaZpZ90';

const loadGmap = (callbackName: string): void => {
    if ($('#gmapScript').length) return;
    const s = document.createElement('script');
    s.id = 'gmapScript';
    s.type = 'text/javascript';
    s.src =
        'https://maps.googleapis.com/maps/api/js?v=3.exp&key=' +
        GMAP_KEY +
        '&libraries=places' +
        (callbackName ? '&callback=' + callbackName : '');
    $('head').append(s);
};

export { loadGmap };
